import { useNavigate } from "@tanstack/react-router";
import type { Uuid } from "spacetimedb";

import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import { shareableCardUrl } from "@/web/routes/_protected/smb/-dashboard/-actions/share/ShareBusinessCardAction";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  /** The card whose published page this completed card reflects. Drives the
   * "View live page" link at `/ttw/<cardId>`. */
  cardId: Uuid;
};

/**
 * Completed-side compose card. Appears once a composer (TTW) page exists for the
 * brand's card. The primary action reopens the composer to edit in place; the
 * Details face links out to the live public page.
 */
function ComposeTtwCompleted({ cardId }: Props) {
  const navigate = useNavigate();

  return (
    <CompletedActionCard
      category="fundraise"
      badge="Fundraise"
      title="Your investor page"
      action={{
        label: "Edit",
        onClick: () => navigate({ to: "/profile/compose" }),
      }}
      details={{
        title: "Your investor page",
        children: (
          <a
            href={shareableCardUrl(cardId)}
            target="_blank"
            rel="noreferrer"
            className="font-medium underline underline-offset-2"
          >
            View live page →
          </a>
        ),
      }}
    />
  );
}

export function createComposeTtwCompleted(props: Props & { id?: string }): SmbActionDefinition {
  const { cardId, id = `compose-ttw:done:${cardId.toString()}` } = props;
  return {
    id,
    category: "fundraise",
    canSkip: false,
    render: () => <ComposeTtwCompleted cardId={cardId} />,
  };
}
